import styled, { ITheme } from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const NestedNotificationHeader = styled.div<IWithSize>`
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  width: 100%;
  line-height: normal;
  letter-spacing: 0.14px;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
`

export default NestedNotificationHeader
